export default __webpack_public_path__ + "7c8140c0676ebb30213beaf8acb79b64.svg";